
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5cc2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5cc2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iyjrR", function(module, exports) {
module.exports = import("8BShk").then(()=>parcelRequire('jaZ7o'));

});

parcelRegister("8ZFBQ", function(module, exports) {
module.exports = import("ilUZb").then(()=>parcelRequire('6fGU3'));

});

const $c9407a767cd80aee$export$1f12680e68c5100d = {
    en: {
        'Enter names below': 'Enter names below',
        Shuffle: 'Shuffle',
        Start: 'Start',
        Map: 'Map',
        Recording: 'Recording',
        'The winner is': 'The winner is',
        'Using skills': 'Using skills',
        'Buy me a coffee': 'Buy me a coffee',
        First: 'First',
        Last: 'Last',
        'Wheel of fortune': 'Wheel of fortune',
        BubblePop: 'BubblePop',
        'Pot of greed': 'Pot of greed',
        'Yoru ni Kakeru': 'Into The Night (by item4)',
        'Shake!': 'Shake!',
        'Input names separated by commas or line feed here': 'Input names separated by commas or line feed here',
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': 'This program is freeware and may be used freely anywhere, including in broadcasts and videos.',
        'Close': 'Close',
        'The result has been copied': 'The result has been copied',
        '2025 Recap': '2025 Recap'
    },
    ko: {
        'Enter names below': "\uC774\uB984\uB4E4\uC744 \uC785\uB825\uD558\uC138\uC694",
        Shuffle: "\uC11E\uAE30",
        Start: "\uC2DC\uC791",
        Map: "\uB9F5",
        Recording: "\uB179\uD654",
        'The winner is': "\uB2F9\uCCA8 \uC21C\uC704",
        'Using skills': "\uC2A4\uD0AC \uD65C\uC131\uD654",
        'Buy me a coffee': "\uAC1C\uBC1C\uC790\uC5D0\uAC8C \uCEE4\uD53C \uC0AC\uC8FC\uAE30",
        First: "\uCCAB\uBC88\uC9F8",
        Last: "\uB9C8\uC9C0\uB9C9",
        'Wheel of fortune': "\uC6B4\uBA85\uC758 \uC218\uB808\uBC14\uD034",
        BubblePop: "\uBC84\uBE14\uD31D",
        'Pot of greed': "\uC695\uB9DD\uC758 \uD56D\uC544\uB9AC",
        'Yoru ni Kakeru': "\uBC24\uC744 \uB2EC\uB9AC\uB2E4 (by item4)",
        'Shake!': "\uD754\uB4E4\uAE30!",
        'Input names separated by commas or line feed here': "\uC774\uB984\uB4E4\uC744 \uC27C\uD45C\uB098 \uC5D4\uD130\uB85C \uAD6C\uBD84\uD574\uC11C \uB123\uC5B4\uC8FC\uC138\uC694",
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': "\uC774 \uD504\uB85C\uADF8\uB7A8\uC740 \uD504\uB9AC\uC6E8\uC5B4\uC774\uBA70 \uBC29\uC1A1\uC774\uB098 \uC601\uC0C1 \uB4F1\uC744 \uD3EC\uD568\uD55C \uC5B4\uB5A4 \uC6A9\uB3C4\uB85C\uB4E0 \uC790\uC720\uB86D\uAC8C \uC0AC\uC6A9\uD558\uB294 \uAC83\uC774 \uD5C8\uC6A9\uB418\uC5B4\uC788\uC2B5\uB2C8\uB2E4.",
        'Close': "\uB2EB\uAE30",
        'The result has been copied': "\uACB0\uACFC\uAC00 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        '2025 Recap': "2025 \uACB0\uC0B0"
    }
};


const $f38b96567aa47566$var$defaultLocale = 'en';
let $f38b96567aa47566$var$locale;
function $f38b96567aa47566$var$getBrowserLocale() {
    return navigator.language.split('-')[0];
}
function $f38b96567aa47566$var$translateElement(element) {
    if (!(element instanceof HTMLElement) || !$f38b96567aa47566$var$locale) return;
    const prop = element.getAttribute('data-trans');
    if (prop) {
        const key = (element.getAttribute(prop) || '').trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.setAttribute(prop, (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key]);
    } else {
        const key = element.innerText.trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.innerText = (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key];
    }
}
function $f38b96567aa47566$var$translatePage() {
    document.querySelectorAll('[data-trans]').forEach($f38b96567aa47566$var$translateElement);
}
function $f38b96567aa47566$var$setLocale(newLocale) {
    if (newLocale === $f38b96567aa47566$var$locale) return;
    document.documentElement.lang = newLocale;
    const newLocaleLower = newLocale.toLocaleLowerCase();
    $f38b96567aa47566$var$locale = newLocaleLower in (0, $c9407a767cd80aee$export$1f12680e68c5100d) ? newLocaleLower : $f38b96567aa47566$var$defaultLocale;
    $f38b96567aa47566$var$translatePage();
}
document.addEventListener('DOMContentLoaded', ()=>{
    console.log('localization loaded');
    const browserLocale = $f38b96567aa47566$var$getBrowserLocale();
    console.log('detected locale: ', browserLocale);
    $f38b96567aa47566$var$setLocale(browserLocale);
});
// eslint-disable-next-line
window.translateElement = $f38b96567aa47566$var$translateElement;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


const $1d1927fc5b91d8b6$export$c2cc40734f29867c = 30;
const $1d1927fc5b91d8b6$export$1cd840e6ecaab774 = 1600;
const $1d1927fc5b91d8b6$export$3d795bc15e02aca = 900;
const $1d1927fc5b91d8b6$export$677ef9a3ce6796cf = 5;
const $1d1927fc5b91d8b6$export$2708cc8cc9b2d975 = 5000;
var $1d1927fc5b91d8b6$export$bc572fe44976cfbc = /*#__PURE__*/ function(Skills) {
    Skills[Skills["None"] = 0] = "None";
    Skills[Skills["Impact"] = 1] = "Impact";
    return Skills;
}({});
const $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd = {
    box: 'cyan',
    circle: 'yellow',
    polyline: 'white'
};
const $1d1927fc5b91d8b6$export$452bc121f02cf9e8 = {
    box: 'cyan',
    circle: 'yellow',
    polyline: 'cyan'
};
const $1d1927fc5b91d8b6$export$1d8e462b9ec86de2 = {
    light: {
        background: '#eee',
        marbleLightness: 50,
        marbleWinningBorder: 'black',
        skillColor: '#69c',
        coolTimeIndicator: '#999',
        entity: {
            box: {
                fill: '#226f92',
                outline: 'black',
                bloom: 'cyan',
                bloomRadius: 0
            },
            circle: {
                fill: 'yellow',
                outline: '#ed7e11',
                bloom: 'yellow',
                bloomRadius: 0
            },
            polyline: {
                fill: 'white',
                outline: 'black',
                bloom: 'cyan',
                bloomRadius: 0
            }
        },
        rankStroke: 'black',
        minimapBackground: '#fefefe',
        minimapViewport: '#6699cc',
        winnerBackground: 'rgba(255, 255, 255, 0.5)',
        winnerOutline: 'black',
        winnerText: '#cccccc'
    },
    dark: {
        background: 'black',
        marbleLightness: 75,
        marbleWinningBorder: 'white',
        skillColor: 'white',
        coolTimeIndicator: 'red',
        entity: {
            box: {
                fill: 'cyan',
                outline: 'cyan',
                bloom: 'cyan',
                bloomRadius: 15
            },
            circle: {
                fill: 'yellow',
                outline: 'yellow',
                bloom: 'yellow',
                bloomRadius: 15
            },
            polyline: {
                fill: 'white',
                outline: 'white',
                bloom: 'cyan',
                bloomRadius: 15
            }
        },
        rankStroke: '',
        minimapBackground: '#333333',
        minimapViewport: 'white',
        winnerBackground: 'rgba(0, 0, 0, 0.5)',
        winnerOutline: 'black',
        winnerText: 'white'
    }
};


function $28770b279d7ab5b1$export$29e4e862bebba87f(degree) {
    return Math.PI * degree / 180;
}
function $28770b279d7ab5b1$var$getRegexValue(regex, str) {
    const result = regex.exec(str);
    return result ? result[1] : '';
}
function $28770b279d7ab5b1$export$5d945868514965a9(nameStr) {
    const weightRegex = /\/(\d+)/;
    const countRegex = /\*(\d+)/;
    const hasWeight = weightRegex.test(nameStr);
    const hasCount = countRegex.test(nameStr);
    const name = $28770b279d7ab5b1$var$getRegexValue(/^\s*([^\/*]+)?/, nameStr);
    if (!name) return null;
    const weight = hasWeight ? parseInt($28770b279d7ab5b1$var$getRegexValue(weightRegex, nameStr)) : 1;
    const count = hasCount ? parseInt($28770b279d7ab5b1$var$getRegexValue(countRegex, nameStr)) : 1;
    return {
        name: name,
        weight: weight,
        count: count
    };
}
function $28770b279d7ab5b1$export$5d04458e2a6c373e(v) {
    return v.toString().padStart(2, '0');
}
function $28770b279d7ab5b1$export$448332262467e042(originalArray) {
    const array = originalArray.slice();
    let currentIndex = array.length;
    let randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex !== 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
}


class $2573268c577c952d$var$Options {
    constructor(){
        this.useSkills = true;
        this.winningRank = 0;
        this.autoRecording = true;
    }
}
const $2573268c577c952d$var$options = new $2573268c577c952d$var$Options();
var $2573268c577c952d$export$2e2bcd8739ae039 = $2573268c577c952d$var$options;


class $5aa23f633f590d4c$export$9b781de7bf37bf48 {
    static sub(v1, v2) {
        return {
            x: v2.x - v1.x,
            y: v2.y - v1.y
        };
    }
    static lenSq(v) {
        return v.x * v.x + v.y * v.y;
    }
    static len(v) {
        return Math.sqrt(this.lenSq(v));
    }
    static mul(v, scalar) {
        return {
            x: v.x * scalar,
            y: v.y * scalar
        };
    }
    static add(v1, v2) {
        return {
            x: v1.x + v2.x,
            y: v1.y + v2.y
        };
    }
}


function $925f553a3559c299$export$b1ef7103be47635(ctx, func) {
    const originalTransform = ctx.getTransform();
    func(ctx);
    ctx.setTransform(originalTransform);
}


class $e7b6517817360fee$export$e91dba6fa3f67f68 {
    get position() {
        return this.physics.getMarblePosition(this.id) || {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    get x() {
        return this.position.x;
    }
    set x(v) {
        this.position.x = v;
    }
    get y() {
        return this.position.y;
    }
    set y(v) {
        this.position.y = v;
    }
    get angle() {
        return this.position.angle;
    }
    constructor(physics, order, max, name, weight = 1){
        this.type = 'marble';
        this.name = '';
        this.size = 0.5;
        this.color = 'red';
        this.hue = 0;
        this.impact = 0;
        this.weight = 1;
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        this.isActive = false;
        this._skillRate = 0.0005;
        this._coolTime = 5000;
        this._maxCoolTime = 5000;
        this._stuckTime = 0;
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        this.name = name || `M${order}`;
        this.weight = weight;
        this.physics = physics;
        this._maxCoolTime = 1000 + (1 - this.weight) * 4000;
        this._coolTime = this._maxCoolTime * Math.random();
        this._skillRate = 0.2 * this.weight;
        const maxLine = Math.ceil(max / 10);
        const line = Math.floor(order / 10);
        const lineDelta = -Math.max(0, Math.ceil(maxLine - 5));
        this.hue = 360 / max * order;
        this.color = `hsl(${this.hue} 100% 50%)`;
        this.id = order;
        physics.createMarble(order, 10.25 + order % 10 * 0.6, maxLine - line + lineDelta);
    }
    update(deltaTime) {
        if (this.isActive && (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).lenSq((0, $5aa23f633f590d4c$export$9b781de7bf37bf48).sub(this.lastPosition, this.position)) < 0.00001) {
            this._stuckTime += deltaTime;
            if (this._stuckTime > (0, $1d1927fc5b91d8b6$export$2708cc8cc9b2d975)) {
                this.physics.shakeMarble(this.id);
                this._stuckTime = 0;
            }
        } else this._stuckTime = 0;
        this.lastPosition = {
            x: this.position.x,
            y: this.position.y
        };
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        if (this.impact) this.impact = Math.max(0, this.impact - deltaTime);
        if (!this.isActive) return;
        if ((0, $2573268c577c952d$export$2e2bcd8739ae039).useSkills) this._updateSkillInformation(deltaTime);
    }
    _updateSkillInformation(deltaTime) {
        if (this._coolTime > 0) this._coolTime -= deltaTime;
        if (this._coolTime <= 0) {
            this.skill = Math.random() < this._skillRate ? (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact : (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
            this._coolTime = this._maxCoolTime;
        }
    }
    render(ctx, zoom, outline, isMinimap = false, skin, viewPort, theme) {
        this.theme = theme;
        const viewPortHw = viewPort.w / viewPort.zoom / 2;
        const viewPortHh = viewPort.h / viewPort.zoom / 2;
        const viewPortLeft = viewPort.x - viewPortHw;
        const viewPortRight = viewPort.x + viewPortHw;
        const viewPortTop = viewPort.y - viewPortHh - this.size / 2;
        const viewPortBottom = viewPort.y + viewPortHh;
        // 화면 밖 최적화
        if (!isMinimap && (this.x < viewPortLeft || this.x > viewPortRight || this.y < viewPortTop || this.y > viewPortBottom)) return;
        const transform = ctx.getTransform();
        if (isMinimap) this._renderMinimap(ctx);
        else this._renderNormal(ctx, zoom, outline, skin);
        ctx.setTransform(transform);
    }
    _renderMinimap(ctx) {
        ctx.fillStyle = `hsl(${this.hue} 100% 50%)`;
        this._drawMarbleBody(ctx, true);
    }
    _drawMarbleBody(ctx, isMinimap) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, isMinimap ? this.size : this.size / 2, 0, Math.PI * 2);
        ctx.fill();
    }
    _renderNormal(ctx, zoom, outline, skin) {
        const hs = this.size / 2;
        if (skin) {
            // 1. 이미지가 있을 때
            ctx.save();
            ctx.translate(this.x, this.y);
            ctx.rotate(this.angle);
            // 원형 클리핑
            ctx.beginPath();
            ctx.arc(0, 0, hs, 0, Math.PI * 2);
            ctx.clip();
            // 이미지 그리기
            ctx.drawImage(skin, -hs, -hs, hs * 2, hs * 2);
            ctx.restore();
        } else {
            // 2. 이미지가 없을 때 (색깔 공)
            ctx.fillStyle = `hsl(${this.hue} 100% ${50 + 25 * Math.min(1, this.impact / 500)}%)`;
            this._drawMarbleBody(ctx, false);
        }
        ctx.shadowColor = '';
        ctx.shadowBlur = 0;
        // 이름 그리기
        this._drawName(ctx, zoom);
    // [삭제됨] 테두리 그리는 코드 삭제 (_drawOutline 호출 제거)
    // [삭제됨] 스킬 쿨타임 테두리 그리는 코드 삭제 (_renderCoolTime 호출 제거)
    }
    _drawName(ctx, zoom) {
        (0, $925f553a3559c299$export$b1ef7103be47635)(ctx, ()=>{
            // 폰트 변경: sans-serif -> Jua
            ctx.font = `bold 14pt Jua`;
            // 글씨가 잘 보이도록 외곽선(검은색)은 유지 (이건 공 테두리가 아니라 글자 테두리입니다)
            ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)';
            ctx.lineWidth = 3;
            ctx.fillStyle = 'white';
            ctx.translate(this.x, this.y + 0.3);
            ctx.scale(1 / zoom, 1 / zoom);
            ctx.strokeText(this.name, 0, 0);
            ctx.fillText(this.name, 0, 0);
        });
    }
    // [참고] 아래 함수들은 더 이상 호출되지 않지만, 클래스 멤버로 남겨두거나 지워도 무방합니다.
    _drawOutline(ctx, lineWidth) {
        ctx.beginPath();
        ctx.strokeStyle = this.theme.marbleWinningBorder;
        ctx.lineWidth = lineWidth;
        ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
        ctx.stroke();
    }
    _renderCoolTime(ctx, zoom) {
        ctx.strokeStyle = this.theme.coolTimeIndicator;
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size / 2 + 2 / zoom, (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270), (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270 + 360 * this._coolTime / this._maxCoolTime));
        ctx.stroke();
    }
}





const $2139b4f99d5088b5$var$lifetime = 3000;
class $2139b4f99d5088b5$export$c36c68baa13912a5 {
    constructor(x, y){
        this._elapsed = 0;
        this.position = {
            x: 0,
            y: 0
        };
        this.force = {
            x: 0,
            y: 0
        };
        this.color = '';
        this.isDestroy = false;
        this.position.x = x;
        this.position.y = y;
        const force = Math.random() * 250;
        const ang = (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(90 * Math.random() - 180);
        const fx = Math.cos(ang) * force;
        const fy = Math.sin(ang) * force;
        this.color = `hsl(${Math.random() * 360} 50% 50%)`;
        this.force = {
            x: fx,
            y: fy
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        const delta = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).mul(this.force, deltaTime / 100);
        this.position = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).add(this.position, delta);
        this.force.y += 10 * deltaTime / 100;
        if (this._elapsed > $2139b4f99d5088b5$var$lifetime) this.isDestroy = true;
    }
    render(ctx) {
        ctx.save();
        ctx.globalAlpha = 1 - Math.pow(this._elapsed / $2139b4f99d5088b5$var$lifetime, 2);
        ctx.fillStyle = this.color;
        ctx.fillRect(this.position.x, this.position.y, 20, 20);
        ctx.restore();
    }
}


class $69fffa06e2cc8da9$export$6658904c50100579 {
    update(deltaTime) {
        this._particles.forEach((particle)=>{
            particle.update(deltaTime);
        });
        this._particles = this._particles.filter((particle)=>!particle.isDestroy);
    }
    render(ctx) {
        this._particles.forEach((particle)=>particle.render(ctx));
    }
    shot(x, y) {
        for(let i = 0; i < 200; i++)this._particles.push(new (0, $2139b4f99d5088b5$export$c36c68baa13912a5)(x, y));
    }
    constructor(){
        this._particles = [];
    }
}


const $b2abafc93d11a512$export$1bfcff8d7c4bf05 = [
    {
        title: 'Wheel of fortune',
        goalY: 111,
        zoomY: 106.75,
        entities: [
            // polyline
            {
                position: {
                    x: 0,
                    y: 0
                },
                shape: {
                    type: 'polyline',
                    points: [
                        [
                            16.5,
                            -300
                        ],
                        [
                            9.25,
                            -300
                        ],
                        [
                            9.25,
                            8.5
                        ],
                        [
                            2,
                            19.25
                        ],
                        [
                            2,
                            26
                        ],
                        [
                            9.75,
                            30
                        ],
                        [
                            9.75,
                            33.5
                        ],
                        [
                            1.25,
                            41
                        ],
                        [
                            1.25,
                            53.75
                        ],
                        [
                            8.25,
                            58.75
                        ],
                        [
                            8.25,
                            63
                        ],
                        [
                            9.25,
                            64
                        ],
                        [
                            8.25,
                            65
                        ],
                        [
                            8.25,
                            99.25
                        ],
                        [
                            15.1,
                            106.75
                        ],
                        [
                            15.1,
                            111.75
                        ]
                    ],
                    rotation: 0
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            16.5,
                            -300
                        ],
                        [
                            16.5,
                            9.25
                        ],
                        [
                            9.5,
                            20
                        ],
                        [
                            9.5,
                            22.5
                        ],
                        [
                            17.5,
                            26
                        ],
                        [
                            17.5,
                            33.5
                        ],
                        [
                            24,
                            38.5
                        ],
                        [
                            19,
                            45.5
                        ],
                        [
                            19,
                            55.5
                        ],
                        [
                            24,
                            59.25
                        ],
                        [
                            24,
                            63
                        ],
                        [
                            23,
                            64
                        ],
                        [
                            24,
                            65
                        ],
                        [
                            24,
                            100.5
                        ],
                        [
                            16,
                            106.75
                        ],
                        [
                            16,
                            111.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            12.75,
                            37.5
                        ],
                        [
                            7,
                            43.5
                        ],
                        [
                            7,
                            49.75
                        ],
                        [
                            12.75,
                            53.75
                        ],
                        [
                            12.75,
                            37.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            14.75,
                            37.5
                        ],
                        [
                            14.75,
                            43
                        ],
                        [
                            17.5,
                            40.25
                        ],
                        [
                            14.75,
                            37.5
                        ]
                    ]
                }
            },
            // boxes
            {
                position: {
                    x: 15.5,
                    y: 30.0
                },
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 32
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 28
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 30
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 32
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 28
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.4,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.3,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.1,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.9,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.699999999999996,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.7,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.4,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.3,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.1,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.9,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.699999999999996,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.7,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.75,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.25,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.25,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.75,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.75,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.25,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            // wheels
            {
                position: {
                    x: 8,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 24,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14,
                    y: 106.75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -1.2,
                    restitution: 0
                }
            }
        ]
    },
    {
        'title': 'BubblePop',
        'goalY': 83,
        'zoomY': 78,
        'entities': [
            {
                'type': 'static',
                'position': {
                    'x': 10.375,
                    'y': -108.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            6.125,
                            -191.5
                        ],
                        [
                            -1.125,
                            -191.5
                        ],
                        [
                            -1.125,
                            108.5
                        ],
                        [
                            -1.125,
                            151.5
                        ],
                        [
                            -6.125,
                            158.5
                        ],
                        [
                            -1.125,
                            161.5
                        ],
                        [
                            -1.125,
                            179.5
                        ],
                        [
                            -0.9128679656440362,
                            179.7498817789222
                        ],
                        [
                            -1.125,
                            179.9997635578444
                        ],
                        [
                            -1.125,
                            183.5
                        ],
                        [
                            1.625,
                            188.5
                        ],
                        [
                            1.625,
                            191.5
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.25,
                    'y': -108.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            0.25,
                            -191.5
                        ],
                        [
                            0.25,
                            158.5
                        ],
                        [
                            3.25,
                            162.5
                        ],
                        [
                            2.25,
                            164.5
                        ],
                        [
                            3.25,
                            166.5
                        ],
                        [
                            0.25,
                            169.5
                        ],
                        [
                            0.25,
                            179.5
                        ],
                        [
                            0.03786796564403616,
                            179.75925677892224
                        ],
                        [
                            0.25,
                            179.9997635578444
                        ],
                        [
                            0.25,
                            183.5
                        ],
                        [
                            -3.25,
                            188.5
                        ],
                        [
                            -3.25,
                            191.5
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.5,
                    'y': 55.75
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            0,
                            -3.25
                        ],
                        [
                            1,
                            -1.75
                        ],
                        [
                            0,
                            0.25
                        ],
                        [
                            1,
                            2.25
                        ],
                        [
                            0,
                            3.25
                        ],
                        [
                            -1,
                            0.25
                        ],
                        [
                            0,
                            -3.25
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.375,
                    'y': 48.25
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            -1.125,
                            -2.75
                        ],
                        [
                            -4.125,
                            1.25
                        ],
                        [
                            -1.125,
                            2.75
                        ],
                        [
                            4.125,
                            2.25
                        ],
                        [
                            -1.125,
                            -2.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.15625,
                    'y': 26.75
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            -0.90625,
                            -0.75
                        ],
                        [
                            0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.59375,
                    'y': 26.75
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            0.90625,
                            -0.75
                        ],
                        [
                            -0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.875,
                    'y': 29.25
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            -1.8125,
                            0.75
                        ],
                        [
                            0,
                            -0.75
                        ],
                        [
                            1.8125,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.15625,
                    'y': 31.75
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            -0.90625,
                            -0.75
                        ],
                        [
                            0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.59375,
                    'y': 31.75
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            0.90625,
                            -0.75
                        ],
                        [
                            -0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.875,
                    'y': 34.25
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'polyline',
                    'rotation': 0,
                    'points': [
                        [
                            -1.8125,
                            0.75
                        ],
                        [
                            0,
                            -0.75
                        ],
                        [
                            1.8125,
                            0.75
                        ]
                    ]
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 9.25,
                    'y': 18
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 11.25,
                    'y': 18
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13.25,
                    'y': 18
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.25,
                    'y': 18
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.5,
                    'y': 19
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.5,
                    'y': 19
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 14.5,
                    'y': 19
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.5,
                    'y': 19
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 9.25,
                    'y': 20
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 11.25,
                    'y': 20
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13.25,
                    'y': 20
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.25,
                    'y': 20
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.5,
                    'y': 21
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.5,
                    'y': 21
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 14.5,
                    'y': 21
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.5,
                    'y': 21
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 9.25,
                    'y': 22
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 11.25,
                    'y': 22
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13.25,
                    'y': 22
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.25,
                    'y': 22
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.5,
                    'y': 23
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.5,
                    'y': 23
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 14.5,
                    'y': 23
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.5,
                    'y': 23
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 0.15,
                    'height': 0.15
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 9.400000000000002,
                    'y': 39
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 3,
                    'height': 3
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 16.5,
                    'y': 43
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0.7853981633974483,
                    'width': 3,
                    'height': 3
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 10.7,
                    'y': 10
                },
                'props': {
                    'angularVelocity': 10,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 0.5,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 14.7,
                    'y': 10
                },
                'props': {
                    'angularVelocity': -10,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 0.5,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 12.7,
                    'y': 10
                },
                'props': {
                    'angularVelocity': 10,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 0.5,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 10.7,
                    'y': 14
                },
                'props': {
                    'angularVelocity': -3,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 2,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 14.7,
                    'y': 14
                },
                'props': {
                    'angularVelocity': 3,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 2,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 11.2,
                    'y': 44
                },
                'props': {
                    'angularVelocity': -5,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 0.5,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 10.3,
                    'y': 75
                },
                'props': {
                    'angularVelocity': 8,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 1,
                    'height': 0.1
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 15.462132034355964,
                    'y': 75
                },
                'props': {
                    'angularVelocity': -8,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 1,
                    'height': 0.1
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 11,
                    'y': 65
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13,
                    'y': 65
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15,
                    'y': 65
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12,
                    'y': 67.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 14,
                    'y': 67.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13,
                    'y': 69.77058813837772
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.8
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 10.7,
                    'y': 77.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.8
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 14.7,
                    'y': 77.5
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.8
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.625,
                    'y': 80
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 1.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 12.625,
                    'y': 80
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 1.2
                }
            },
            {
                'type': 'kinematic',
                'position': {
                    'x': 12.625,
                    'y': 56.00000000000001
                },
                'props': {
                    'angularVelocity': -8,
                    'density': 1,
                    'restitution': 0
                },
                'shape': {
                    'type': 'box',
                    'rotation': 0,
                    'width': 1,
                    'height': 0.1
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 9.947604593262161,
                    'y': 62.59581680393866
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 11.947604593262161,
                    'y': 62.59581680393866
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 13.947604593262161,
                    'y': 62.59581680393866
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            },
            {
                'type': 'static',
                'position': {
                    'x': 15.828283102570442,
                    'y': 62.59581680393866
                },
                'props': {
                    'angularVelocity': 0,
                    'density': 1,
                    'restitution': 1.5,
                    'life': 1
                },
                'shape': {
                    'type': 'circle',
                    'radius': 0.5
                }
            }
        ]
    },
    {
        title: 'Pot of greed',
        goalY: 111,
        zoomY: 110,
        entities: [
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            17,
                            -300
                        ],
                        [
                            9,
                            -300
                        ],
                        [
                            9,
                            8.5
                        ],
                        [
                            2,
                            15
                        ],
                        [
                            6,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            7,
                            71
                        ],
                        [
                            9,
                            101
                        ],
                        [
                            8,
                            100.5
                        ],
                        [
                            6,
                            100
                        ],
                        [
                            5,
                            90
                        ],
                        [
                            4,
                            70
                        ],
                        [
                            7,
                            71
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            17,
                            -300
                        ],
                        [
                            17,
                            8.5
                        ],
                        [
                            24,
                            15
                        ],
                        [
                            20,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            19,
                            71
                        ],
                        [
                            17,
                            101
                        ],
                        [
                            18,
                            100.5
                        ],
                        [
                            20,
                            100
                        ],
                        [
                            21,
                            90
                        ],
                        [
                            22,
                            70
                        ],
                        [
                            19,
                            71
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            11,
                            88
                        ],
                        [
                            12,
                            90
                        ],
                        [
                            12,
                            112
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            15,
                            88
                        ],
                        [
                            14,
                            90
                        ],
                        [
                            14,
                            112
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            12,
                            102
                        ],
                        [
                            11,
                            103
                        ],
                        [
                            9,
                            104
                        ],
                        [
                            8,
                            104
                        ],
                        [
                            6,
                            103
                        ],
                        [
                            5,
                            102
                        ],
                        [
                            4,
                            100
                        ],
                        [
                            3,
                            90
                        ],
                        [
                            2,
                            70
                        ],
                        [
                            3,
                            65
                        ],
                        [
                            4,
                            63
                        ],
                        [
                            5,
                            62
                        ],
                        [
                            6,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            14,
                            102
                        ],
                        [
                            15,
                            103
                        ],
                        [
                            17,
                            104
                        ],
                        [
                            18,
                            104
                        ],
                        [
                            20,
                            103
                        ],
                        [
                            21,
                            102
                        ],
                        [
                            22,
                            100
                        ],
                        [
                            23,
                            90
                        ],
                        [
                            24,
                            70
                        ],
                        [
                            23,
                            65
                        ],
                        [
                            22,
                            63
                        ],
                        [
                            21,
                            62
                        ],
                        [
                            20,
                            61.5
                        ]
                    ]
                }
            },
            {
                position: {
                    x: 13,
                    y: 20
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 3,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 3,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 8,
                    y: 37
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 2,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18,
                    y: 37
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 2,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 12
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 12
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 8,
                    y: 104
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6,
                    y: 103
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4,
                    y: 100
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 95
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3,
                    y: 90
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.75,
                    y: 85
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.5,
                    y: 80
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.25,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2,
                    y: 70
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18,
                    y: 104
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 103
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22,
                    y: 100
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 95
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23,
                    y: 90
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.25,
                    y: 85
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.5,
                    y: 80
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.75,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 24,
                    y: 70
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            }
        ]
    },
    {
        title: 'Yoru ni Kakeru',
        goalY: 248,
        zoomY: 234.5,
        entities: [
            {
                position: {
                    x: 2,
                    y: 0
                },
                shape: {
                    type: 'box',
                    width: 1,
                    height: 800,
                    rotation: 0,
                    color: '#222',
                    bloomColor: '#777'
                },
                type: 'static',
                props: {
                    density: 500,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                type: 'static',
                position: {
                    x: 21,
                    y: 0
                },
                props: {
                    density: 500,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 1,
                    height: 800,
                    color: '#222',
                    bloomColor: '#777'
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 25.0
                },
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 27.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#9bec00'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 37.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff6868'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 32.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#80b3ff'
                },
                props: {
                    density: 2,
                    angularVelocity: 4.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 27.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff6868'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 37.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#9bec00'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 50.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 6.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c5470'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 20.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 20.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 75.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff577f'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 75.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff577f'
                },
                props: {
                    density: 1,
                    angularVelocity: 4.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.0,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 100.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: -2.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 100.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 104.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 104.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 106.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 106.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 112.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 112.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 114.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 114.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 105.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 105.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 130.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#435585'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.25,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 130.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 140.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 30,
                    color: '#610c9f'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 140.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: -30,
                    color: '#872341'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 150.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 60,
                    color: '#503c3c'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 150.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: -60,
                    color: '#5c5470'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 160.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 90,
                    color: '#1a3636'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 160.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: -90,
                    color: '#522258'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 180.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 6.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ccb1b1'
                },
                props: {
                    density: 1,
                    angularVelocity: 4.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 180.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 7.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#b1ccb1'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 195.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 8.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#b3ccff'
                },
                props: {
                    density: 1,
                    angularVelocity: 5.5,
                    restitution: 0
                }
            }
        ]
    }
];




class $238457a12dbae9c5$export$79f141de891a5fed {
    get zoom() {
        return this._zoom;
    }
    set zoom(v) {
        this._targetZoom = v;
    }
    get x() {
        return this._position.x;
    }
    set x(v) {
        this._targetPosition.x = v;
    }
    get y() {
        return this._position.y;
    }
    set y(v) {
        this._targetPosition.y = v;
    }
    get position() {
        return this._position;
    }
    setPosition(v, force = false) {
        if (force) return this._position = {
            x: v.x,
            y: v.y
        };
        return this._targetPosition = {
            x: v.x,
            y: v.y
        };
    }
    lock(v) {
        this._locked = v;
    }
    startFollowingMarbles() {
        this._shouldFollowMarbles = true;
    }
    initializePosition() {
        const centerX = 12.95;
        const initialY = 2;
        this._position = {
            x: centerX,
            y: initialY
        };
        this._targetPosition = {
            x: centerX,
            y: initialY
        };
        this._shouldFollowMarbles = false;
    }
    update({ marbles: marbles, stage: stage, needToZoom: needToZoom, targetIndex: targetIndex }) {
        // set target position
        if (!this._locked) this._calcTargetPositionAndZoom(marbles, stage, needToZoom, targetIndex);
        // interpolate position
        this._position.x = this._interpolation(this.x, this._targetPosition.x);
        this._position.y = this._interpolation(this.y, this._targetPosition.y);
        // interpolate zoom
        this._zoom = this._interpolation(this._zoom, this._targetZoom);
    }
    _calcTargetPositionAndZoom(marbles, stage, needToZoom, targetIndex) {
        if (!this._shouldFollowMarbles) return;
        if (marbles.length > 0) {
            const targetMarble = marbles[targetIndex] ? marbles[targetIndex] : marbles[0];
            this.setPosition(targetMarble.position);
            if (needToZoom) {
                const goalDist = Math.abs(stage.zoomY - this._position.y);
                this.zoom = Math.max(1, (1 - goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) * 4);
            } else this.zoom = 1;
        } else this.zoom = 1;
    }
    _interpolation(current, target) {
        const d = target - current;
        if (Math.abs(d) < 1 / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)) return target;
        return current + d / 10;
    }
    renderScene(ctx, callback) {
        const zoomFactor = (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * 2 * this._zoom;
        ctx.save();
        ctx.translate(-this.x * this._zoom, -this.y * this._zoom);
        ctx.scale(this.zoom, this.zoom);
        ctx.translate(ctx.canvas.width / zoomFactor, ctx.canvas.height / zoomFactor);
        callback(ctx);
        ctx.restore();
    }
    constructor(){
        this._position = {
            x: 0,
            y: 0
        };
        this._targetPosition = {
            x: 0,
            y: 0
        };
        this._zoom = 1;
        this._targetZoom = 1;
        this._locked = false;
        this._shouldFollowMarbles = false;
    }
}



const $917e2e33c0ac0dc1$var$KEYWORDS_URL = 'https://marblerouletteshop.com/api/external/keywords.json';
const $917e2e33c0ac0dc1$var$SPRITE_BASE_URL = 'https://marblerouletteshop.com/api/external/sprites';
const $917e2e33c0ac0dc1$var$REFRESH_INTERVAL = 60000; // 60 seconds
class $917e2e33c0ac0dc1$export$ea2bb5c7a344080e {
    async init() {
        await this.fetchKeywords();
        this._startPeriodicRefresh();
    }
    destroy() {
        if (this._intervalId !== null) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }
    _startPeriodicRefresh() {
        this._intervalId = window.setInterval(()=>{
            if (document.visibilityState === 'visible') this.fetchKeywords();
        }, $917e2e33c0ac0dc1$var$REFRESH_INTERVAL);
    }
    async fetchKeywords() {
        try {
            const response = await fetch($917e2e33c0ac0dc1$var$KEYWORDS_URL);
            if (!response.ok) {
                console.warn(`[KeywordService] Failed to fetch keywords: ${response.status}`);
                return;
            }
            const newData = await response.json();
            console.log(`[KeywordService] Fetched ${Object.keys(newData.keywords ?? {}).length} keywords`);
            // Check if generated_at is newer than last load
            const isNewer = this._lastGeneratedAt === null || new Date(newData.generated_at) > new Date(this._lastGeneratedAt);
            if (isNewer) {
                // Clear sprite caches when data is updated
                this._spriteSheets.clear();
                this._extractedSprites.clear();
                this._loadingSprites.clear();
                console.log('[KeywordService] Data updated, clearing sprite caches');
            }
            this._keywordsData = newData;
            this._lastGeneratedAt = newData.generated_at;
            // Preload sprite sheets for all keywords
            const spriteIds = new Set();
            for (const entry of Object.values(this._keywordsData.keywords))spriteIds.add(entry.sprite);
            await Promise.all([
                ...spriteIds
            ].map((id)=>this._loadSpriteSheet(id)));
        } catch (error) {
            console.warn('[KeywordService] Error fetching keywords:', error);
        }
    }
    async _loadSpriteSheet(spriteId) {
        if (this._spriteSheets.has(spriteId)) return this._spriteSheets.get(spriteId);
        // Check if already loading
        if (this._loadingSprites.has(spriteId)) return this._loadingSprites.get(spriteId);
        const loadPromise = new Promise((resolve)=>{
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = ()=>{
                this._spriteSheets.set(spriteId, img);
                console.log(`[KeywordService] Loaded sprite sheet ${spriteId}`);
                resolve(img);
            };
            img.onerror = ()=>{
                console.warn(`[KeywordService] Failed to load sprite sheet ${spriteId}`);
                resolve(null);
            };
            img.src = `${$917e2e33c0ac0dc1$var$SPRITE_BASE_URL}/${spriteId}.png?generated_at=${encodeURIComponent(this._lastGeneratedAt ?? '')}`;
        });
        this._loadingSprites.set(spriteId, loadPromise);
        const result = await loadPromise;
        this._loadingSprites.delete(spriteId);
        return result;
    }
    _extractSprite(spriteSheet, x, y, width, height) {
        const canvas = typeof OffscreenCanvas !== 'undefined' ? new OffscreenCanvas(width, height) : document.createElement('canvas');
        if (!(canvas instanceof OffscreenCanvas)) {
            canvas.width = width;
            canvas.height = height;
        }
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.drawImage(spriteSheet, x, y, width, height, 0, 0, width, height);
        return canvas;
    }
    getSprite(marbleName) {
        if (!this._keywordsData) return undefined;
        const entry = this._keywordsData.keywords[marbleName];
        if (!entry) return undefined;
        // Check expiration
        if (new Date(entry.expires_at) < new Date()) return undefined;
        // Check cache first
        const cacheKey = `${entry.sprite}_${entry.x}_${entry.y}_${entry.width}_${entry.height}`;
        if (this._extractedSprites.has(cacheKey)) return this._extractedSprites.get(cacheKey);
        // Get sprite sheet
        const spriteSheet = this._spriteSheets.get(entry.sprite);
        if (!spriteSheet) return undefined;
        // Extract and cache the sprite
        const sprite = this._extractSprite(spriteSheet, entry.x, entry.y, entry.width, entry.height);
        this._extractedSprites.set(cacheKey, sprite);
        return sprite;
    }
    constructor(){
        this._keywordsData = null;
        this._spriteSheets = new Map();
        this._extractedSprites = new Map();
        this._intervalId = null;
        this._loadingSprites = new Map();
        this._lastGeneratedAt = null;
    }
}


var $c92bc92e6f43beb5$exports = {};
$c92bc92e6f43beb5$exports = import.meta.resolve("cdgIR");


var $bcc86b8ef80c3516$exports = {};
$bcc86b8ef80c3516$exports = import.meta.resolve("lfSvD");


var $fde943b0087de629$exports = {};
$fde943b0087de629$exports = import.meta.resolve("juMvj");


var $c3ee37d79087d41f$exports = {};
$c3ee37d79087d41f$exports = import.meta.resolve("f8LDQ");


var $39cda126ef66d2fb$exports = {};
$39cda126ef66d2fb$exports = import.meta.resolve("lcJUm");


var $547e8d41d88bd7fc$exports = {};
$547e8d41d88bd7fc$exports = import.meta.resolve("29RBH");


var $427b16302389831d$exports = {};
$427b16302389831d$exports = import.meta.resolve("iOxuU");


var $dd8a948d2f518516$exports = {};
$dd8a948d2f518516$exports = import.meta.resolve("ez46a");


var $e2c0a45e65e2a754$exports = {};
$e2c0a45e65e2a754$exports = import.meta.resolve("4SCuU");


var $534656af8b1b33b5$exports = {};
$534656af8b1b33b5$exports = import.meta.resolve("2xX8a");


var $f0aec9e706d72a6b$exports = {};
$f0aec9e706d72a6b$exports = import.meta.resolve("hgw7u");


var $443030d446ef9427$exports = {};
$443030d446ef9427$exports = import.meta.resolve("9f164");


class $68facf3481e408fc$export$a1ed140729fa937 {
    constructor(){
        this.sizeFactor = 1;
        this._images = {};
        this._ballImagesPool = [] // 공 이미지 저장소
        ;
        this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        this._keywordService = new (0, $917e2e33c0ac0dc1$export$ea2bb5c7a344080e)();
    }
    get width() {
        return this._canvas.width;
    }
    get height() {
        return this._canvas.height;
    }
    get canvas() {
        return this._canvas;
    }
    set theme(value) {
        this._theme = value;
    }
    // [수정] 이미지 로드 헬퍼 함수
    async _loadImage(url) {
        return new Promise((rs)=>{
            const img = new Image();
            img.onload = ()=>rs(img);
            img.onerror = ()=>{
                console.warn(`[\u{C774}\u{BBF8}\u{C9C0} \u{B85C}\u{B4DC} \u{C2E4}\u{D328}] ${url}`);
                rs(new Image());
            };
            img.src = url;
        });
    }
    async init() {
        console.log("[RouletteRenderer] \uCD08\uAE30\uD654 \uC2DC\uC791...");
        // 키워드 서비스와 이미지 로드 병렬 처리
        await Promise.all([
            this._load(),
            this._keywordService.init()
        ]);
        this._canvas = document.createElement('canvas');
        this._canvas.width = (0, $1d1927fc5b91d8b6$export$1cd840e6ecaab774);
        this._canvas.height = (0, $1d1927fc5b91d8b6$export$3d795bc15e02aca);
        this.ctx = this._canvas.getContext('2d', {
            alpha: false
        });
        document.body.appendChild(this._canvas);
        const resizing = (entries)=>{
            const realSize = entries ? entries[0].contentRect : this._canvas.getBoundingClientRect();
            const width = Math.max(realSize.width / 2, 640);
            const height = width / realSize.width * realSize.height;
            this._canvas.width = width;
            this._canvas.height = height;
            this.sizeFactor = width / realSize.width;
        };
        const resizeObserver = new ResizeObserver(resizing);
        resizeObserver.observe(this._canvas);
        resizing();
    }
    async _load() {
        const loadPromises = [];
        // 1. 특정 이름 이미지 로드
        const namedImages = [
            {
                name: "\uCC54\uB8E8",
                imgUrl: new URL($c92bc92e6f43beb5$exports)
            },
            {
                name: "\uCFE0\uBE48",
                imgUrl: new URL($bcc86b8ef80c3516$exports)
            }
        ];
        namedImages.forEach(({ name: name, imgUrl: imgUrl })=>{
            loadPromises.push((async ()=>{
                try {
                    const img = await this._loadImage(imgUrl.toString());
                    if (img.width > 0) this._images[name] = img;
                } catch (e) {}
            })());
        });
        loadPromises.push((async ()=>{
            try {
                await this._loadImage(new URL($fde943b0087de629$exports).toString());
            } catch (e) {}
        })());
        // 2. [수정] 공 이미지 로드 (1.png ~ 9.png)
        const ballUrls = [
            new URL($c3ee37d79087d41f$exports),
            new URL($39cda126ef66d2fb$exports),
            new URL($547e8d41d88bd7fc$exports),
            new URL($427b16302389831d$exports),
            new URL($dd8a948d2f518516$exports),
            new URL($e2c0a45e65e2a754$exports),
            new URL($534656af8b1b33b5$exports),
            new URL($f0aec9e706d72a6b$exports),
            new URL($443030d446ef9427$exports)
        ];
        const loadedImages = await Promise.all(ballUrls.map((url)=>this._loadImage(url.toString())));
        loadedImages.forEach((img)=>{
            if (img.width > 0) this._ballImagesPool.push(img);
        });
        await Promise.all(loadPromises);
    }
    getMarbleImage(name) {
        if (this._images[name]) return this._images[name];
        // [수정] 에러 수정: getImageForName -> getSprite
        return this._keywordService.getSprite(name);
    }
    render(renderParameters, uiObjects) {
        this._theme = renderParameters.theme;
        this.ctx.fillStyle = this._theme.background; // [수정] bgColor -> background
        this.ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
        this.ctx.save();
        this.ctx.scale((0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        this.ctx.textAlign = 'left';
        this.ctx.textBaseline = 'top';
        this.ctx.font = '0.4pt Jua'; // [수정] 디버그 폰트도 Jua로 변경
        this.ctx.lineWidth = 3 / (renderParameters.camera.zoom + (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        renderParameters.camera.renderScene(this.ctx, ()=>{
            this.renderEntities(renderParameters.entities);
            this.renderEffects(renderParameters);
            this.renderMarbles(renderParameters);
        });
        this.ctx.restore();
        uiObjects.forEach((obj)=>obj.render(this.ctx, renderParameters, this._canvas.width, this._canvas.height));
        renderParameters.particleManager.render(this.ctx);
        this.renderWinner(renderParameters);
    }
    renderEntities(entities) {
        this.ctx.save();
        entities.forEach((entity)=>{
            const transform = this.ctx.getTransform();
            // [수정] position.x -> x 로 변경 (에러 해결)
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            const shape = entity.shape;
            // [수정] color -> shape.color (에러 해결)
            this.ctx.fillStyle = shape.color ?? this._theme.entity[shape.type].fill;
            this.ctx.strokeStyle = shape.color ?? this._theme.entity[shape.type].outline;
            this.ctx.shadowBlur = this._theme.entity[shape.type].bloomRadius;
            this.ctx.shadowColor = shape.bloomColor ?? shape.color ?? this._theme.entity[shape.type].bloom;
            switch(shape.type){
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
                case 'box':
                    const w = shape.width * 2;
                    const h = shape.height * 2;
                    this.ctx.rotate(shape.rotation);
                    this.ctx.fillRect(-w / 2, -h / 2, w, h);
                    this.ctx.strokeRect(-w / 2, -h / 2, w, h);
                    break;
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
            }
            this.ctx.setTransform(transform);
        });
        this.ctx.restore();
    }
    renderEffects({ effects: effects, camera: camera }) {
        effects.forEach((effect)=>effect.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), this._theme));
    }
    renderMarbles({ marbles: marbles, camera: camera, winnerRank: winnerRank, winners: winners, size: size, ballImage: ballImage }) {
        const winnerIndex = winnerRank - winners.length;
        const viewPort = {
            x: camera.x,
            y: camera.y,
            w: size.x,
            h: size.y,
            zoom: camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble, i)=>{
            let imageToUse = this.getMarbleImage(marble.name);
            // [수정] 공 이미지 풀에서 가져오기 로직 추가
            if (!imageToUse && this._ballImagesPool.length > 0) imageToUse = this._ballImagesPool[marble.id % this._ballImagesPool.length];
            if (!imageToUse) imageToUse = ballImage;
            // [수정] 원래 인자 개수 7개 유지
            marble.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), i === winnerIndex, false, imageToUse, viewPort, this._theme);
        });
    }
    renderWinner({ winner: winner, theme: theme }) {
        if (!winner) return;
        this.ctx.save();
        this.ctx.fillStyle = theme.winnerBackground;
        this.ctx.fillRect(this._canvas.width / 2, this._canvas.height - 168, this._canvas.width / 2, 168);
        const marbleSize = 100;
        const marbleCenterX = this._canvas.width - marbleSize / 2 - 20;
        const marbleCenterY = this._canvas.height - 84;
        let marbleImage = this.getMarbleImage(winner.name);
        // [수정] 우승자 이미지 풀 로직 추가
        if (!marbleImage && this._ballImagesPool.length > 0) marbleImage = this._ballImagesPool[winner.id % this._ballImagesPool.length];
        if (marbleImage) this.ctx.drawImage(marbleImage, marbleCenterX - marbleSize / 2, marbleCenterY - marbleSize / 2, marbleSize, marbleSize);
        else {
            this.ctx.beginPath();
            this.ctx.arc(marbleCenterX, marbleCenterY, marbleSize / 2, 0, Math.PI * 2);
            this.ctx.fillStyle = `hsl(${winner.hue} 100% ${theme.marbleLightness})`;
            this.ctx.fill();
        }
        this.ctx.fillStyle = theme.winnerText;
        this.ctx.strokeStyle = theme.winnerOutline;
        // [수정] 우승자 텍스트 Jua 폰트로 변경
        this.ctx.font = '48px Jua';
        this.ctx.textAlign = 'right';
        this.ctx.lineWidth = 4;
        const textRightX = marbleCenterX - marbleSize / 2 - 20;
        if (theme.winnerOutline) this.ctx.strokeText('Winner', textRightX, this._canvas.height - 120);
        this.ctx.fillText('Winner', textRightX, this._canvas.height - 120);
        // [수정] 우승자 이름 Jua 폰트로 변경
        this.ctx.font = '72px Jua';
        this.ctx.fillStyle = `hsl(${winner.hue} 100% ${theme.marbleLightness})`;
        if (theme.winnerOutline) this.ctx.strokeText(winner.name, textRightX, this._canvas.height - 55);
        this.ctx.fillText(winner.name, textRightX, this._canvas.height - 55);
        this.ctx.restore();
    }
}


const $43c01f2b0f9df660$var$lifetime = 500;
class $43c01f2b0f9df660$export$2faf2590ac4901e1 {
    constructor(x, y){
        this._size = 0;
        this._elapsed = 0;
        this.isDestroy = false;
        this.position = {
            x: x,
            y: y
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        this._size = this._elapsed / $43c01f2b0f9df660$var$lifetime * 10;
        if (this._elapsed > $43c01f2b0f9df660$var$lifetime) this.isDestroy = true;
    }
    render(ctx, zoom, theme) {
        ctx.save();
        const rate = this._elapsed / $43c01f2b0f9df660$var$lifetime;
        ctx.globalAlpha = 1 - rate * rate;
        ctx.strokeStyle = theme.skillColor;
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.position.x, this.position.y, this._size, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }
}



function $5d9d2ddcc4e90c63$export$adf7c0fe6059d774(// eslint-disable-next-line
target, propertyKey, descriptor) {
    return {
        configurable: true,
        get () {
            const boundMethod = descriptor.value.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: boundMethod,
                configurable: true,
                writable: true
            });
            return boundMethod;
        }
    };
}




class $e0350dec16bbe919$export$795f70ffe4ca76fc {
    constructor(){
        this._currentY = 0;
        this._targetY = 0;
        this.fontHeight = 24 // [수정] 폰트 크기에 맞춰 줄 간격 조정
        ;
        this._userMoved = 0;
        this._currentWinner = -1;
        this.maxY = 0;
        this.winners = [];
        this.marbles = [];
        this.winnerRank = -1;
    }
    onWheel(e) {
        this._targetY += e.deltaY;
        if (this._targetY > this.maxY) this._targetY = this.maxY;
        this._userMoved = 2000;
    }
    onDblClick(e) {
        if (e) {
            if (navigator.clipboard) {
                const tsv = [];
                let rank = 0;
                tsv.push(...[
                    ...this.winners,
                    ...this.marbles
                ].map((m)=>{
                    rank++;
                    return [
                        rank.toString(),
                        m.name,
                        rank - 1 === this.winnerRank ? "\u2606" : ''
                    ].join('\t');
                }));
                tsv.unshift([
                    'Rank',
                    'Name',
                    'Winner'
                ].join('\t'));
                navigator.clipboard.writeText(tsv.join('\n')).then(()=>{
                    if (this.messageHandler) this.messageHandler('The result has been copied');
                });
            }
        }
    }
    onMessage(func) {
        this.messageHandler = func;
    }
    render(ctx, { winners: winners, marbles: marbles, winnerRank: winnerRank, theme: theme }, width, height) {
        const startX = width - 10;
        const startY = Math.max(-this.fontHeight, this._currentY - height / 2);
        this.maxY = Math.max(0, (marbles.length + winners.length) * this.fontHeight + this.fontHeight);
        this._currentWinner = winners.length;
        this.winners = winners;
        this.marbles = marbles;
        this.winnerRank = winnerRank;
        ctx.save();
        ctx.textAlign = 'right';
        // [수정] 폰트 변경 (Jua)
        ctx.font = '16px Jua';
        // [수정] 에러 해결: theme.textColor 대신 흰색(#fff) 사용
        ctx.fillStyle = '#fff';
        ctx.fillText(`${winners.length} / ${winners.length + marbles.length}`, width - 10, this.fontHeight);
        ctx.beginPath();
        ctx.rect(width - 220, this.fontHeight + 2, width, this.maxY); // 너비 조금 넓힘
        ctx.clip();
        ctx.translate(0, -startY);
        // [수정] 리스트 폰트 변경 (Jua)
        ctx.font = '20px Jua';
        if (theme.rankStroke) {
            ctx.lineWidth = 2;
            ctx.strokeStyle = theme.rankStroke;
        }
        winners.forEach((marble, rank)=>{
            const y = rank * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}`;
                ctx.strokeText(`${rank === winnerRank ? "\u2606" : '\u2714'} ${marble.name} #${rank + 1}`, startX, 20 + y);
                ctx.fillText(`${rank === winnerRank ? "\u2606" : '\u2714'} ${marble.name} #${rank + 1}`, startX, 20 + y);
            }
        });
        // [수정] 참가자 목록 폰트 변경 (Jua)
        ctx.font = '18px Jua';
        marbles.forEach((marble, rank)=>{
            const y = (rank + winners.length) * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}`;
                ctx.strokeText(`${marble.name} #${rank + 1 + winners.length}`, startX, 20 + y);
                ctx.fillText(`${marble.name} #${rank + 1 + winners.length}`, startX, 20 + y);
            }
        });
        ctx.restore();
    }
    update(deltaTime) {
        if (this._currentWinner === -1) return;
        if (this._userMoved > 0) this._userMoved -= deltaTime;
        else this._targetY = this._currentWinner * this.fontHeight + this.fontHeight;
        if (this._currentY !== this._targetY) this._currentY += (this._targetY - this._currentY) * (deltaTime / 250);
        if (Math.abs(this._currentY - this._targetY) < 1) this._currentY = this._targetY;
    }
    getBoundingBox() {
        return null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onWheel", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onDblClick", null);





class $c2ea39beabe51779$export$a8b4308ba35ee473 {
    constructor(){
        this.lastParams = null;
        this._onViewportChangeHandler = null;
        this.mousePosition = null;
        this.boundingBox = {
            x: 10,
            y: 10,
            w: 104,
            h: 0
        };
    }
    getBoundingBox() {
        return this.boundingBox;
    }
    onViewportChange(callback) {
        this._onViewportChangeHandler = callback;
    }
    update() {
    // nothing to do
    }
    onMouseMove(e) {
        if (!e) {
            this.mousePosition = null;
            if (this._onViewportChangeHandler) this._onViewportChangeHandler();
            return;
        }
        if (!this.lastParams) return;
        this.mousePosition = {
            x: e.x,
            y: e.y
        };
        if (this._onViewportChangeHandler) this._onViewportChangeHandler({
            x: this.mousePosition.x / 4,
            y: this.mousePosition.y / 4
        });
    }
    render(ctx, params) {
        if (!ctx) return;
        const { stage: stage } = params;
        if (!stage) return;
        this.boundingBox.h = stage.goalY * 4;
        this.lastParams = params;
        this.ctx = ctx;
        ctx.save();
        ctx.fillStyle = params.theme.minimapBackground;
        ctx.translate(10, 10);
        ctx.scale(4, 4);
        ctx.fillRect(0, 0, 26, stage.goalY);
        this.ctx.lineWidth = 3 / (params.camera.zoom + (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        this.drawEntities(params.entities, params.theme);
        this.drawMarbles(params);
        this.drawViewport(params);
        ctx.restore();
        ctx.save();
        ctx.strokeStyle = 'green';
        ctx.lineWidth = 1;
        ctx.strokeRect(this.boundingBox.x, this.boundingBox.y, this.boundingBox.w, this.boundingBox.h);
        ctx.restore();
    }
    drawViewport(params) {
        this.ctx.save();
        const { camera: camera, size: size } = params;
        const zoom = camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c);
        const w = size.x / zoom;
        const h = size.y / zoom;
        this.ctx.strokeStyle = params.theme.minimapViewport;
        this.ctx.lineWidth = 1 / zoom;
        this.ctx.strokeRect(camera.x - w / 2, camera.y - h / 2, w, h);
        this.ctx.restore();
    }
    drawEntities(entities, theme) {
        this.ctx.save();
        entities.forEach((entity)=>{
            this.ctx.save();
            this.ctx.fillStyle = entity.shape.color ?? theme.entity[entity.shape.type].fill;
            this.ctx.strokeStyle = entity.shape.color ?? theme.entity[entity.shape.type].outline;
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            this.ctx.save();
            const shape = entity.shape;
            switch(shape.type){
                case 'box':
                    const w = shape.width * 2;
                    const h = shape.height * 2;
                    this.ctx.rotate(shape.rotation);
                    this.ctx.fillRect(-w / 2, -h / 2, w, h);
                    break;
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
            }
            this.ctx.restore();
            this.ctx.restore();
        });
        this.ctx.restore();
    }
    drawMarbles(params) {
        const { marbles: marbles } = params;
        const viewPort = {
            x: params.camera.x,
            y: params.camera.y,
            w: params.size.x,
            h: params.size.y,
            zoom: params.camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble)=>{
            marble.render(this.ctx, 1, false, true, undefined, viewPort, params.theme);
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $c2ea39beabe51779$export$a8b4308ba35ee473.prototype, "onMouseMove", null);



class $ba1c8fec6a2b59e4$export$ec9e02cabe22c790 {
    constructor(canvas){
        this.chunks = [];
        this.stopping = false;
        this.targetCanvas = canvas;
        this.videoStream = this.targetCanvas.captureStream();
        this.mediaRecorder = new MediaRecorder(this.videoStream, {
            videoBitsPerSecond: 6000000
        });
    }
    async start() {
        this.stopping = false;
        return new Promise((rs)=>{
            this.chunks = [];
            this.mediaRecorder.ondataavailable = (e)=>{
                this.chunks.push(e.data);
            };
            this.mediaRecorder.onstop = ()=>{
                const blob = new Blob(this.chunks, {
                    type: 'video/mp4'
                });
                const videoUrl = URL.createObjectURL(blob);
                const downloadLink = document.createElement('a');
                const d = new Date();
                downloadLink.href = videoUrl;
                downloadLink.download = `marble_roulette_${d.getFullYear()}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getMonth() + 1)}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getDate())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getHours())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getMinutes())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getSeconds())}.mp4`;
                downloadLink.click();
                downloadLink.remove();
                URL.revokeObjectURL(videoUrl);
            };
            this.mediaRecorder.onstart = ()=>{
                rs();
            };
            this.mediaRecorder.start();
        });
    }
    stop() {
        this.stopping = true;
        if (this.mediaRecorder.state === 'recording') this.mediaRecorder.stop();
    }
}


/**
 * @param {Parameters<import('box2d-wasm')>} args
 * @return {ReturnType<import('box2d-wasm')>}
 */ 

var $e6be656c8b5afbd4$export$2e2bcd8739ae039 = async (...args)=>{
    /**
   * This validation expression comes from wasm-feature-detect:
   * https://github.com/GoogleChromeLabs/wasm-feature-detect
   * 
   * Copyright 2019 Google Inc. All Rights Reserved.
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *     http://www.apache.org/licenses/LICENSE-2.0
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */ const hasSIMD = WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));
    /** @type {{ 'default': import('box2d-wasm') }} */ const Box2DModule = await (hasSIMD ? (parcelRequire("iyjrR")) : (parcelRequire("8ZFBQ")));
    const { 'default': Box2DFactory } = Box2DModule;
    // awaiting gives us a better stack trace (at the cost of an extra microtask)
    return await Box2DFactory(...args);
};


class $fafe2abfa7f98b9f$export$81ba3d9458692cc2 {
    async init() {
        this.Box2D = await (0, $e6be656c8b5afbd4$export$2e2bcd8739ae039)();
        this.gravity = new this.Box2D.b2Vec2(0, 10);
        this.world = new this.Box2D.b2World(this.gravity);
        console.log('box2d ready');
    }
    clear() {
        this.clearEntities();
    }
    clearMarbles() {
        Object.values(this.marbleMap).forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.marbleMap = {};
    }
    createStage(stage) {
        this.createEntities(stage.entities);
    }
    createEntities(entities) {
        if (!entities) return;
        const bodyTypes = {
            static: this.Box2D.b2_staticBody,
            kinematic: this.Box2D.b2_kinematicBody
        };
        entities.forEach((entity)=>{
            const bodyDef = new this.Box2D.b2BodyDef();
            bodyDef.set_type(bodyTypes[entity.type]);
            const body = this.world.CreateBody(bodyDef);
            const fixtureDef = new this.Box2D.b2FixtureDef();
            fixtureDef.set_density(entity.props.density);
            fixtureDef.set_restitution(entity.props.restitution);
            let shape;
            switch(entity.shape.type){
                case 'box':
                    shape = new this.Box2D.b2PolygonShape();
                    shape.SetAsBox(entity.shape.width, entity.shape.height, 0, entity.shape.rotation);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
                case 'polyline':
                    shape = new this.Box2D.b2EdgeShape();
                    for(let i = 0; i < entity.shape.points.length - 1; i++){
                        const p1 = entity.shape.points[i];
                        const p2 = entity.shape.points[i + 1];
                        const v1 = new this.Box2D.b2Vec2(p1[0], p1[1]);
                        const v2 = new this.Box2D.b2Vec2(p2[0], p2[1]);
                        const edge = new this.Box2D.b2EdgeShape();
                        edge.SetTwoSided(v1, v2);
                        body.CreateFixture(edge, 1);
                    }
                    break;
                case 'circle':
                    shape = new this.Box2D.b2CircleShape();
                    shape.set_m_radius(entity.shape.radius);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
            }
            body.SetAngularVelocity(entity.props.angularVelocity);
            body.SetTransform(new this.Box2D.b2Vec2(entity.position.x, entity.position.y), 0);
            this.entities.push({
                body: body,
                x: entity.position.x,
                y: entity.position.y,
                angle: 0,
                shape: entity.shape,
                life: entity.props.life ?? -1
            });
        });
    }
    clearEntities() {
        this.entities.forEach((entity)=>{
            this.world.DestroyBody(entity.body);
        });
        this.entities = [];
    }
    createMarble(id, x, y) {
        const circleShape = new this.Box2D.b2CircleShape();
        circleShape.set_m_radius(0.25);
        const bodyDef = new this.Box2D.b2BodyDef();
        bodyDef.set_type(this.Box2D.b2_dynamicBody);
        bodyDef.set_position(new this.Box2D.b2Vec2(x, y));
        const body = this.world.CreateBody(bodyDef);
        body.CreateFixture(circleShape, 1 + Math.random());
        body.SetAwake(false);
        body.SetEnabled(false);
        this.marbleMap[id] = body;
    }
    shakeMarble(id) {
        const body = this.marbleMap[id];
        if (body) body.ApplyLinearImpulseToCenter(new this.Box2D.b2Vec2(Math.random() * 10 - 5, Math.random() * 10 - 5), true);
    }
    removeMarble(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            this.world.DestroyBody(marble);
            delete this.marbleMap[id];
        }
    }
    getMarblePosition(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            const pos = marble.GetPosition();
            return {
                x: pos.x,
                y: pos.y,
                angle: marble.GetAngle()
            };
        } else return {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    getEntities() {
        return this.entities.map((entity)=>{
            return {
                ...entity,
                angle: entity.body.GetAngle()
            };
        });
    }
    impact(id) {
        const src = this.marbleMap[id];
        if (!src) return;
        Object.values(this.marbleMap).forEach((body)=>{
            if (body === src) return;
            const distVector = new this.Box2D.b2Vec2(body.GetPosition().x, body.GetPosition().y);
            distVector.op_sub(src.GetPosition());
            const distSq = distVector.LengthSquared();
            if (distSq < 100) {
                distVector.Normalize();
                const power = 1 - distVector.Length() / 10;
                distVector.op_mul(power * power * 5);
                body.ApplyLinearImpulseToCenter(distVector, true);
            }
        });
    }
    start() {
        for(const key in this.marbleMap){
            const marble = this.marbleMap[key];
            marble.SetAwake(true);
            marble.SetEnabled(true);
        }
    }
    step(deltaSeconds) {
        this.deleteCandidates.forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.deleteCandidates = [];
        this.world.Step(deltaSeconds, 6, 2);
        for(let i = this.entities.length - 1; i >= 0; i--){
            const entity = this.entities[i];
            if (entity.life > 0) {
                const edge = entity.body.GetContactList();
                if (edge.contact && edge.contact.IsTouching()) {
                    this.deleteCandidates.push(entity.body);
                    this.entities.splice(i, 1);
                }
            }
        }
    }
    constructor(){
        this.marbleMap = {};
        this.entities = [];
        this.deleteCandidates = [];
    }
}



class $edfb0080e3205638$export$bdce5325d183ff94 {
    constructor(){
        this.bound = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this.isEnabled = false;
        this.icon = new Image();
        this.icon.src = new URL($fde943b0087de629$exports).toString();
    }
    get speed() {
        return this.isEnabled ? 2 : 1;
    }
    update(deltaTime) {}
    render(ctx, params, width, height) {
        this.bound.w = width / 2;
        this.bound.h = height / 2;
        this.bound.x = this.bound.w / 2;
        this.bound.y = this.bound.h / 2;
        const centerX = this.bound.x + this.bound.w / 2;
        const centerY = this.bound.y + this.bound.h / 2;
        if (this.isEnabled) {
            ctx.save();
            ctx.strokeStyle = 'white';
            ctx.globalAlpha = 0.5;
            ctx.drawImage(this.icon, centerX - 100, centerY - 100, 200, 200);
            ctx.restore();
        }
    }
    getBoundingBox() {
        return this.bound;
    }
    onMouseDown(e) {
        this.isEnabled = true;
    }
    onMouseUp(e) {
        this.isEnabled = false;
    }
}


class $7c756c59aac10daa$export$4929751e8471403 extends EventTarget {
    // [삭제됨] private _ballImage 변수 삭제 (Renderer가 알아서 함)
    get isReady() {
        return this._isReady;
    }
    constructor(){
        super(), this._marbles = [], this._lastTime = 0, this._elapsed = 0, this._updateInterval = 10, this._timeScale = 1, this._speed = 1, this._winners = [], this._particleManager = new (0, $69fffa06e2cc8da9$export$6658904c50100579)(), this._stage = null, this._camera = new (0, $238457a12dbae9c5$export$79f141de891a5fed)(), this._renderer = new (0, $68facf3481e408fc$export$a1ed140729fa937)(), this._effects = [], this._winnerRank = 0, this._totalMarbleCount = 0, this._goalDist = Infinity, this._isRunning = false, this._winner = null, this._uiObjects = [], this._autoRecording = false, this._isReady = false, this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        // [삭제됨] this._ballImage.src = ... 부분 삭제 (에러 원인 제거)
        this._renderer.init().then(()=>{
            this._init().then(()=>{
                this._isReady = true;
                this._update();
            });
        });
    }
    getZoom() {
        return (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * this._camera.zoom;
    }
    addUiObject(obj) {
        this._uiObjects.push(obj);
        if (obj.onWheel) this._renderer.canvas.addEventListener('wheel', obj.onWheel);
        if (obj.onMessage) obj.onMessage((msg)=>{
            console.log('onMessage', msg);
            this.dispatchEvent(new CustomEvent('message', {
                detail: msg
            }));
        });
    }
    _update() {
        if (!this._lastTime) this._lastTime = Date.now();
        const currentTime = Date.now();
        this._elapsed += (currentTime - this._lastTime) * this._speed * this.fastForwarder.speed;
        if (this._elapsed > 100) this._elapsed %= 100;
        this._lastTime = currentTime;
        const interval = this._updateInterval / 1000 * this._timeScale;
        while(this._elapsed >= this._updateInterval){
            this.physics.step(interval);
            this._updateMarbles(this._updateInterval);
            this._particleManager.update(this._updateInterval);
            this._updateEffects(this._updateInterval);
            this._elapsed -= this._updateInterval;
            this._uiObjects.forEach((obj)=>obj.update(this._updateInterval));
        }
        if (this._marbles.length > 1) this._marbles.sort((a, b)=>b.y - a.y);
        if (this._stage) this._camera.update({
            marbles: this._marbles,
            stage: this._stage,
            needToZoom: this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf),
            targetIndex: this._winners.length > 0 ? this._winnerRank - this._winners.length : 0
        });
        this._render();
        window.requestAnimationFrame(this._update);
    }
    _updateMarbles(deltaTime) {
        if (!this._stage) return;
        for(let i = 0; i < this._marbles.length; i++){
            const marble = this._marbles[i];
            marble.update(deltaTime);
            if (marble.skill === (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact) {
                this._effects.push(new (0, $43c01f2b0f9df660$export$2faf2590ac4901e1)(marble.x, marble.y));
                this.physics.impact(marble.id);
            }
            if (marble.y > this._stage.goalY) {
                this._winners.push(marble);
                if (this._isRunning && this._winners.length === this._winnerRank + 1) {
                    this.dispatchEvent(new CustomEvent('goal', {
                        detail: {
                            winner: marble.name
                        }
                    }));
                    this._winner = marble;
                    this._isRunning = false;
                    this._particleManager.shot(this._renderer.width, this._renderer.height);
                    setTimeout(()=>{
                        this._recorder.stop();
                    }, 1000);
                } else if (this._isRunning && this._winnerRank === this._winners.length && this._winnerRank === this._totalMarbleCount - 1) {
                    this.dispatchEvent(new CustomEvent('goal', {
                        detail: {
                            winner: this._marbles[i + 1].name
                        }
                    }));
                    this._winner = this._marbles[i + 1];
                    this._isRunning = false;
                    this._particleManager.shot(this._renderer.width, this._renderer.height);
                    setTimeout(()=>{
                        this._recorder.stop();
                    }, 1000);
                }
                setTimeout(()=>{
                    this.physics.removeMarble(marble.id);
                }, 500);
            }
        }
        const targetIndex = this._winnerRank - this._winners.length;
        const topY = this._marbles[targetIndex] ? this._marbles[targetIndex].y : 0;
        this._goalDist = Math.abs(this._stage.zoomY - topY);
        this._timeScale = this._calcTimeScale();
        this._marbles = this._marbles.filter((marble)=>marble.y <= this._stage.goalY);
    }
    _calcTimeScale() {
        if (!this._stage) return 1;
        const targetIndex = this._winnerRank - this._winners.length;
        if (this._winners.length < this._winnerRank + 1 && this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) {
            if (this._marbles[targetIndex].y > this._stage.zoomY - (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 1.2 && (this._marbles[targetIndex - 1] || this._marbles[targetIndex + 1])) return Math.max(0.2, this._goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf));
        }
        return 1;
    }
    _updateEffects(deltaTime) {
        this._effects.forEach((effect)=>effect.update(deltaTime));
        this._effects = this._effects.filter((effect)=>!effect.isDestroy);
    }
    _render() {
        if (!this._stage) return;
        const renderParams = {
            camera: this._camera,
            stage: this._stage,
            entities: this.physics.getEntities(),
            marbles: this._marbles,
            winners: this._winners,
            particleManager: this._particleManager,
            effects: this._effects,
            winnerRank: this._winnerRank,
            winner: this._winner,
            size: {
                x: this._renderer.width,
                y: this._renderer.height
            },
            theme: this._theme
        };
        // @ts-ignore
        this._renderer.render(renderParams, this._uiObjects);
    }
    async _init() {
        this._recorder = new (0, $ba1c8fec6a2b59e4$export$ec9e02cabe22c790)(this._renderer.canvas);
        this.physics = new (0, $fafe2abfa7f98b9f$export$81ba3d9458692cc2)();
        await this.physics.init();
        this.addUiObject(new (0, $e0350dec16bbe919$export$795f70ffe4ca76fc)());
        this.attachEvent();
        const minimap = new (0, $c2ea39beabe51779$export$a8b4308ba35ee473)();
        minimap.onViewportChange((pos)=>{
            if (pos) {
                this._camera.setPosition(pos, false);
                this._camera.lock(true);
            } else this._camera.lock(false);
        });
        this.addUiObject(minimap);
        this.fastForwarder = new (0, $edfb0080e3205638$export$bdce5325d183ff94)();
        this.addUiObject(this.fastForwarder);
        this._stage = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[0];
        this._loadMap();
    }
    mouseHandler(eventName, e) {
        const handlerName = `on${eventName}`;
        const sizeFactor = this._renderer.sizeFactor;
        const pos = {
            x: e.offsetX * sizeFactor,
            y: e.offsetY * sizeFactor
        };
        this._uiObjects.forEach((obj)=>{
            if (!obj[handlerName]) return;
            const bounds = obj.getBoundingBox();
            if (!bounds) obj[handlerName]({
                ...pos,
                button: e.button
            });
            else if (bounds && pos.x >= bounds.x && pos.y >= bounds.y && pos.x <= bounds.x + bounds.w && pos.y <= bounds.y + bounds.h) obj[handlerName]({
                x: pos.x - bounds.x,
                y: pos.y - bounds.y,
                button: e.button
            });
            else obj[handlerName](undefined);
        });
    }
    attachEvent() {
        [
            'MouseMove',
            'MouseUp',
            'MouseDown',
            'DblClick'
        ].forEach((ev)=>{
            // @ts-ignore
            this._renderer.canvas.addEventListener(ev.toLowerCase().replace('mouse', 'pointer'), this.mouseHandler.bind(this, ev));
        });
        this._renderer.canvas.addEventListener('contextmenu', (e)=>{
            e.preventDefault();
        });
    }
    _loadMap() {
        if (!this._stage) throw new Error('No map has been selected');
        this.physics.createStage(this._stage);
        this._camera.initializePosition();
    }
    clearMarbles() {
        this.physics.clearMarbles();
        this._winner = null;
        this._winners = [];
        this._marbles = [];
    }
    start() {
        this._isRunning = true;
        this._winnerRank = (0, $2573268c577c952d$export$2e2bcd8739ae039).winningRank;
        if (this._winnerRank >= this._marbles.length) this._winnerRank = this._marbles.length - 1;
        this._camera.startFollowingMarbles();
        if (this._autoRecording) this._recorder.start().then(()=>{
            this.physics.start();
            this._marbles.forEach((marble)=>marble.isActive = true);
        });
        else {
            this.physics.start();
            this._marbles.forEach((marble)=>marble.isActive = true);
        }
    }
    setSpeed(value) {
        if (value <= 0) throw new Error('Speed multiplier must larger than 0');
        this._speed = value;
    }
    setTheme(themeName) {
        this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2)[themeName];
    }
    getSpeed() {
        return this._speed;
    }
    setWinningRank(rank) {
        this._winnerRank = rank;
    }
    setAutoRecording(value) {
        this._autoRecording = value;
    }
    setMarbles(names) {
        this.reset();
        const arr = names.slice();
        let maxWeight = -Infinity;
        let minWeight = Infinity;
        const members = arr.map((nameString)=>{
            const result = (0, $28770b279d7ab5b1$export$5d945868514965a9)(nameString);
            if (!result) return null;
            const { name: name, weight: weight, count: count } = result;
            if (weight > maxWeight) maxWeight = weight;
            if (weight < minWeight) minWeight = weight;
            return {
                name: name,
                weight: weight,
                count: count
            };
        }).filter((member)=>!!member);
        const gap = maxWeight - minWeight;
        let totalCount = 0;
        members.forEach((member)=>{
            if (member) {
                member.weight = 0.1 + (gap ? (member.weight - minWeight) / gap : 0);
                totalCount += member.count;
            }
        });
        const orders = (0, $28770b279d7ab5b1$export$448332262467e042)(Array(totalCount).fill(0).map((_, i)=>i));
        members.forEach((member)=>{
            if (member) for(let j = 0; j < member.count; j++){
                const order = orders.pop() || 0;
                this._marbles.push(new (0, $e7b6517817360fee$export$e91dba6fa3f67f68)(this.physics, order, totalCount, member.name, member.weight));
            }
        });
        this._totalMarbleCount = totalCount;
    }
    _clearMap() {
        this.physics.clear();
        this._marbles = [];
    }
    reset() {
        this.clearMarbles();
        this._clearMap();
        this._loadMap();
        this._goalDist = Infinity;
    }
    getCount() {
        return this._marbles.length;
    }
    getMaps() {
        return (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).map((stage, index)=>{
            return {
                index: index,
                title: stage.title
            };
        });
    }
    setMap(index) {
        if (index < 0 || index > (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).length - 1) throw new Error('Incorrect map number');
        const names = this._marbles.map((marble)=>marble.name);
        this._stage = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[index];
        this.setMarbles(names);
        this._camera.initializePosition();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "_update", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "mouseHandler", null);



function $786dbfa54806ab0b$export$c6245babf0c60892() {
    if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
        const swUrl = `${window.location.origin}/roulette/service-worker.js`;
        navigator.serviceWorker.register(swUrl).then((reg)=>console.log('service worker registered', reg.scope)).catch((err)=>console.error('service worker registration failed', err));
    });
}


(0, $786dbfa54806ab0b$export$c6245babf0c60892)();
const $b4e14b6b8da86996$var$roulette = new (0, $7c756c59aac10daa$export$4929751e8471403)();
// eslint-disable-next-line
window.roulette = $b4e14b6b8da86996$var$roulette;
// eslint-disable-next-line
window.options = (0, $2573268c577c952d$export$2e2bcd8739ae039);


//# sourceMappingURL=pinball.6a05d4ac.js.map
